// src/layout/realestateagent/Profile/calculateAgentProfileCompletion.js

const calculateAgentProfileCompletion = (agentData) => {
    if (!agentData) return 0;

    const fields = [
        { key: "agent_id", weight: 1 },
        { key: "name", weight: 1 },
        { key: "email", weight: 1 },
        { key: "phone_number", weight: 1 },
        { key: "gender", weight: 1 },
    ];

    let filledFields = 0;
    let totalFields = fields.length;

    fields.forEach(({ key }) => {
        const value = agentData[key];
        if (value && value.toString().trim() !== "") {
            filledFields++;
        }
    });

    const percentage = Math.round((filledFields / totalFields) * 100);
    return percentage;
};

export default calculateAgentProfileCompletion;
